import tokens from '@kluein/design-tokens';
import { Button, Box, Stack } from '@mantine/core';
import { ArrowUp } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

type AskKlueShowBoardsProps = {
  onClick?: () => void;
  isPage?: boolean;
  compact?: boolean;
};

const containerStyles = {
  cursor: 'pointer',
};

const compactButtonStyles = {
  fontWeight: tokens.fontWeight.bold,
  fontSize: tokens.fontSize.bodyFont.large,
  color: tokens.color.primitives.blue[350],
  backgroundColor: 'transparent',
  border: 'none',
  outline: 'none',
  cursor: 'pointer',
  textDecoration: 'none',
  whiteSpace: 'nowrap',
  padding: `${tokens.spacing.xxsmall} ${tokens.spacing.medium}`,
  borderRadius: '8px',
};

const AskKlueShowBoards = ({ onClick, isPage }: AskKlueShowBoardsProps) => {
  const { t } = useTranslation('Dashboard');

  if (!isPage) {
    return null;
  }

  return (
    <Box id="ask-klue-page-show-boards-container">
      <Stack align="center" gap={0} style={containerStyles} onClick={onClick}>
        <ArrowUp size={20} color={tokens.color.primitives.blue[350]} />
        <Button unstyled style={compactButtonStyles}>
          {t('Dashboard:askKlue.showMe.viewCompetitorBoards')}
        </Button>
      </Stack>
    </Box>
  );
};

export default AskKlueShowBoards;
